export default function TopBar() {
    return (
        <div className="topbar">
            <div className="topbar-inner">

                {/* Left Section: Contact Info */}
                <div className="topbar-left">
                    <a href="tel:8897388513" className="icon-link" aria-label="Call Us">
                        <i class="fa-solid fa-phone"></i>
                        <span className="contact-text">8897388513</span>
                    </a>
                    <a href="mailto:manabandham07@gmail.com" className="icon-link" aria-label="Email Us">
                        <i class="fa-regular fa-envelope"></i>
                        <span className="contact-text">manabandham07@gmail.com</span>
                    </a>
                </div>

                {/* Center Section: Main Promo */}
                <div className="topbar-center">
                    <span className="promo-tag">New</span>
                    <span className="promo-text">
                        <span>Free shipping on orders over ₹1000</span>
                        <span className="mobile-hide"> · Custom orders welcome</span>
                    </span>
                </div>

                {/* Right Section: Social Media */}
                <div className="topbar-right">
                    <a href="https://www.facebook.com/profile.php?id=61585302155060" className="icon-link social-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                        <i class="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/bandham.in" className="icon-link social-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a href="https://wa.me/918897388513" target="_blank" rel="noopener noreferrer" className="icon-link social-icon" aria-label="WhatsApp">
                        <i class="fa-brands fa-whatsapp"></i>
                    </a>
                </div>

            </div>
        </div>
    );
}